import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { EsportsSlide } from "./esports-slide.model";

@Injectable()
export class EsportsSlideService extends CrudService {
  getRootUrl(): string {
    return "esports-slides";
  }

  save(esportsSlide: EsportsSlide) {
    return super.save(esportsSlide);
  }

  saveMultiple(esportsSlides: Array<EsportsSlide>) {
    return super.saveMultiple(esportsSlides);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/shared/esports-slide.service.ts